import React from "react"

function CpsiORMinutes(){
    return <React.Fragment>
        <iframe title="OR_Utilization" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=0903e17b-fd48-4f38-b072-e8165b5901a1&autoAuth=true&ctid=49423d5d-8d49-4128-b53d-59537808f6ac" allowFullScreen={true}></iframe>
    </React.Fragment>
}

export{CpsiORMinutes}